import React from 'react';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import { Modal } from 'antd';

import RestaurantEditForm from './RestaurantEditForm';

const ModalRestaurant = ({ open, onCancel, restaurantData, setRestaurantData, executeGet }) => {
    const translate = useTranslate();

    return (
        <Modal
            centered
            open={open}
            onCancel={onCancel}
            width={1000}
            footer={[]}
            title={translate.formatMessage(commonMessage.updateRestaurant)}
            destroyOnClose
            maskClosable={false}
            zIndex={999999}
        >
            <RestaurantEditForm restaurantData={restaurantData} setRestaurantData={setRestaurantData} onCancel={onCancel} executeGet={executeGet} />
        </Modal>
    );
};

export default ModalRestaurant;
